module.exports = __webpack_public_path__ + "static/media/jump-fish.c573b632.gif";